import type { FetchContext } from 'ofetch';

const CSRF_COOKIE = 'XSRF-TOKEN';
const CSRF_HEADER = 'X-XSRF-TOKEN';

const fetchOnRequestInterceptor = async ({ options }: FetchContext, forceCSRFRefresh: boolean = false) => {
  let token = useCookie(CSRF_COOKIE).value;

  if (['post', 'delete', 'put', 'patch'].includes(options?.method?.toLowerCase() ?? '')) {
    token = await initCsrf(forceCSRFRefresh);
  }

  options.credentials = 'include';

  const headers = new Headers(options.headers as HeadersInit);
  headers.set('Accept', 'application/json');
  if (token) {
    headers.set(CSRF_HEADER, token);
  }

  options.headers = headers;
};

const resetCsrf = async () => {
  useCookie(CSRF_COOKIE).value = '';
  await nextTick();
};

async function fetchCsrf () {
  const config = useRuntimeConfig();
  await $fetch(config.public.proxyPrefix + '/auth/csrf-cookie', {
    credentials: 'include',
  });
}

async function initCsrf (forceCSRFRefresh: boolean = false) {
  const config = useRuntimeConfig();
  const existingToken = useCookie(CSRF_COOKIE).value;

  if (existingToken && !forceCSRFRefresh) {
    return existingToken;
  }

  await $fetch(config.public.proxyPrefix + '/auth/csrf-cookie', {
    credentials: 'include',
  });

  return useCookie(CSRF_COOKIE).value;
}

export default {
  fetchOnRequestInterceptor,
  resetCsrf,
  fetchCsrf,
};